// @ts-nocheck

import { getObjectKeysAsObject } from "@hopper-b2b/checkout";

export const AuthServices = {};

export const AuthServiceTypes = getObjectKeysAsObject(AuthServices);
